<script setup lang="ts">
  import { useRouter } from '@gat-ship/lib/router'
  import { cn } from '../../lib/utils'
  import { TabsTrigger } from '../ui/tabs'
  import { useGatTab } from './index'
  import type { TabItem } from './index'

  defineOptions({
    inheritAttrs: false
  })

  const tab = defineProps<TabItem>()

  const { modelValue, activeTab } = useGatTab()

  function isSelected(tab: TabItem) {
    return (
      tab.value === activeTab.value ||
      (tab.to && tab.to.name === activeTab.value)
    )
  }
</script>

<template>
  <TabsTrigger
    :value="tab.value ?? tab.to?.name ?? ''"
    :class="
      cn(
        'rounded-sm',
        {
          'hover:bg-background/60 text-secondary-foreground/50 hover:cursor-pointer':
            !isSelected(tab)
        },
        tab.class
      )
    "
    :data-testid="tab.dataTestid"
    :disabled="tab.disabled"
    @click="modelValue = tab.value"
  >
    <slot name="tab" v-bind="{ tab }">
      <slot name="prepend" v-bind="{ tab }" />
      <gat-icon v-if="tab.icon" :icon="tab.icon" class="size-4" />
      {{ tab.text }}
      <slot name="append" v-bind="{ tab }" />
      <div
        v-if="typeof tab.count === 'number' && !tab.disabled"
        class="w-fit items-center justify-center rounded-full px-1.5 py-0 text-center"
        :class="
          tab.value === activeTab
            ? 'bg-secondary text-secondary-foreground'
            : 'text-secondary-foreground/50 bg-muted'
        "
        :style="{ fontSize: '12px' }"
      >
        {{ tab.count }}
      </div>
    </slot>
  </TabsTrigger>
</template>
